<template>
  <sn-radio-group
    v-bind="vuetifyOverrideMixin.bindings"
    class="sn-boolean"
    v-on="$listeners"
  >
    <sn-radio
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
      :data-cy="`${$attrs.id ? $attrs.id + '-' + option.label : option.label}-btn`"
    />
  </sn-radio-group>
</template>

<script>
import snRadioGroup from '../snRadioGroup/snRadioGroup'
import snRadio from '../snRadioGroup/snRadio'
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnBoolean',
  components: { snRadioGroup, snRadio },
  mixins: [vuetifyOverrideMixin],
  // v-radio-group uses 'change' instead of the default 'input' event to track model changes
  // See https://github.com/vuetifyjs/vuetify/blob/75404fb66e61d4b4d5b759506ac0d4c7a56a3755/packages/vuetify/src/mixins/selectable/index.ts#L23
  model: { prop: 'value', event: 'change' },
  data () {
    return {
      vuetifyOverrideMixin: {
        // Supported props: disabled, error, errorMessages, hideDetails, hint, id, mandatory, name, rules, validateOnBlur, value
        overriddenProps: {
          row: true,
          column: false
        }
      }
    }
  },
  computed: {
    options () {
      if (this.$attrs.options) {
        return this.$attrs.options
      } else {
        return [
          {
            label: 'Yes',
            text: 'Yes',
            value: true
          },
          {
            label: 'No',
            text: 'No',
            value: false
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
